"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSetImplAsync = void 0;
var QueryContext_1 = __importDefault(require("./context/QueryContext"));
var AbstractConfigSetImpl_1 = require("./AbstractConfigSetImpl");
var ConfigSetImplAsync = /** @class */ (function (_super) {
    __extends(ConfigSetImplAsync, _super);
    function ConfigSetImplAsync() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigSetImplAsync.prototype.getBoolean = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImplAsync.prototype.getString = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImplAsync.prototype.getInteger = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImplAsync.prototype.getList = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImplAsync.prototype.getObject = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    // Disabled as those variables will be used while implementing wildcard query support.
    /* eslint-disable @typescript-eslint/no-unused-vars */
    ConfigSetImplAsync.prototype.listBoolean = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImplAsync.prototype.listInteger = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImplAsync.prototype.listList = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImplAsync.prototype.listObject = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImplAsync.prototype.listString = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    return ConfigSetImplAsync;
}(AbstractConfigSetImpl_1.AbstractConfigSetImpl));
exports.ConfigSetImplAsync = ConfigSetImplAsync;
